export default "__VITE_ASSET__eb0a8003__"